import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../../components/layout/Layout";

export default function EditTiffinPlan() {
  const [formData, setFormData] = useState({
    name: "",
    duration: 0,
    price : 0
  });
  const [disableBtn, setDisableBtn] = useState(false);

  const location = useLocation();
  const data = location.state.data;

  const navigate = useNavigate();

  console.log("Data", data);

  useEffect(()=>{
    setFormData({
        name : data.name,
        price : data.price,
        duration : data.duration
    })
  },[])

  const handleInputChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisableBtn(true);
    try {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };
      console.log(formData);
      const formdata = new FormData();
      formdata.append("name", formData.name);
      formdata.append("duration", formData?.duration?.toString());
      formdata.append("price", formData?.price?.toString());
      formdata.append("planId", data._id);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/plan/update-plan`,
        formdata,
        { headers }
      );
      if (response.data.success) {
        toast.success(response?.data?.message);
        navigate(-1)
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to edit plan. Please try again.", error);
    }
    setDisableBtn(false);
  };

  return (
    <>
      <Layout>
        <ToastContainer />
        <div>
          <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8 tracking-wide">
            {/* Header */}
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-medium">Update Tiffin Plan</h2>
            </div>
            <div className="mt-10" onSubmit={handleSubmit}>
             <form action="">
                <div className="">
                  <label htmlFor="" className="text-sm">
                    Name
                  </label>{" "}
                  <br />
                  <input
                    type="text"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Enter name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mt-3">
                  <label htmlFor="" className="text-sm">
                    Duration
                  </label>{" "}
                  <br />
                  <input
                    type="number"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Enter duration"
                    name="duration"
                    value={formData.duration}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                  <div className="mt-3">
                  <label htmlFor="" className="text-sm">
                    Price
                  </label>{" "}
                  <br />
                  <input
                    type="number"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Enter price"
                    name="price"
                    value={formData.price}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mt-8 text-end">
                  <button
                    type="submit"
                    className="bg-[#2c2c38] text-white h-[40px] px-8 rounded-md text-sm hover:bg-[#191919]"
                    disabled={disableBtn}
                  >
                    <i className="fa fa-edit"></i>{" "}
                    {disableBtn ? "Editing ..." : "Edit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}
